import { render, staticRenderFns } from "./studentTrainingLayout.vue?vue&type=template&id=1488323c&scoped=true&"
import script from "./studentTrainingLayout.vue?vue&type=script&lang=js&"
export * from "./studentTrainingLayout.vue?vue&type=script&lang=js&"
import style0 from "./studentTrainingLayout.vue?vue&type=style&index=0&id=1488323c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1488323c",
  null
  
)

export default component.exports